import { createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH } from '../../constant';

export interface VerifyLoginMfaPayload {
  challengeId: string;
  otp: string;
  /** "Trust this device" — server returns a device token to skip OTP next time. */
  trustDevice?: boolean;
}

/**
 * The final step of login when the account has MFA enabled — `/login` returns
 * a 202 + `mfaRequired` instead of tokens, and this exchanges the emailed code
 * for the exact same success shape `/login` would have returned directly
 * (accessToken/refreshToken/data/...). Deliberately mirrors `loginApi`'s own
 * shape/error handling, since `loginSlice` (login.ts) handles both actions'
 * fulfilled/rejected cases identically — the same "apply a successful login"
 * effect in Login.tsx completes either way, no separate code path needed.
 */
export const verifyLoginMfaApi = createAsyncThunk(
  'auth/verifyLoginMfa',
  async (payload: VerifyLoginMfaPayload, { rejectWithValue }) => {
    try {
      const res = await fetch(AUTH.VERIFY_LOGIN_MFA_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json();

      if (!res.ok) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
